import React, { FC } from "react";
import SectionCard from "./SectionCard";
import { DevicesOther } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { IMiniScentDevice } from "../../types";
import InfoRow from "./InfoRow";

interface DeviceInfoSectionProps {
  device?: IMiniScentDevice;
  isLoading: boolean;
  translate: any;
}

const DeviceInfoSection: FC<DeviceInfoSectionProps> = ({
  device,
  isLoading,
  translate,
}) => (
  <SectionCard
    title="Informações do Dispositivo"
    icon={<DevicesOther />}
    isLoading={isLoading}
  >
    {device ? (
      <>
        <InfoRow label="Número de Série" value={device.serialNumber} />
        <InfoRow label="ID do Dispositivo" value={device.miniscentDeviceId} />
        <InfoRow label="Mensagem" value={device.message || "N/A"} />
      </>
    ) : (
      <Typography color="text.secondary">
        Nenhuma informação disponível
      </Typography>
    )}
  </SectionCard>
);

export default DeviceInfoSection;
